// extracted by mini-css-extract-plugin
export var black = "_3q-6";
export var brand = "_3q-1";
export var ddefault = "_3q-0";
export var error = "_3q-3";
export var gray = "_3q-2";
export var highContrast = "_3q-8";
export var outline = "_3q-7";
export var success = "_3q-5";
export var warning = "_3q-4";